import { render, staticRenderFns } from "./CollapsibleFormSection.vue?vue&type=template&id=baccc73c&scoped=true"
import script from "./CollapsibleFormSection.vue?vue&type=script&lang=js"
export * from "./CollapsibleFormSection.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleFormSection.vue?vue&type=style&index=0&id=baccc73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baccc73c",
  null
  
)

export default component.exports